
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/billing",
      function () {
        return require("private-next-pages/account/billing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/billing"])
      });
    }
  